/**
 * @license
 * Copyright (C) 2022 Anna Plodari
 * Software proprietario - Tutti i diritti riservati.
 * Registrato SIAE - Sezione OLAF.
 *
 * È vietato qualsiasi utilizzo non autorizzato, copia, modifica, estrazione,
 * riuso, rielaborazione, distribuzione, reverse engineering o decompilazione
 * del software, delle API, delle logiche applicative e dei dati del database.
 *
 * L'accesso al codice non costituisce concessione di licenza.
 */
import dayjs from 'dayjs';
import { DATE_FORMAT } from '../constants';

export default function formatDate(date: string | undefined) {
  if (!date) {
    return '';
  }

  return dayjs(date).format(DATE_FORMAT);
}